import React, { Component } from 'react';
import AuthService from '../AuthService';
import constants from '../../config';

var Auth = new AuthService();

var inputCls = 'tw-w-full tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-rounded-lg tw-px-4 tw-py-2.5 tw-text-sm tw-bg-white dark:tw-bg-[#141414] tw-text-[#1a1a1a] dark:tw-text-white tw-outline-none focus:tw-border-brand-gold tw-transition-colors';
var inputSmCls = 'tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-rounded-lg tw-px-2 tw-py-1 tw-text-xs tw-bg-white dark:tw-bg-[#141414] tw-text-[#1a1a1a] dark:tw-text-white tw-outline-none focus:tw-border-brand-gold tw-transition-colors';
var labelCls = 'tw-block tw-text-xs tw-font-semibold tw-text-[#999] dark:tw-text-gray-500 tw-mb-1';

function inputStyle(isDark) {
  return { backgroundColor: isDark ? '#1a1a1a' : '#fff', borderColor: isDark ? '#333' : '#e0e0e0' };
}

function resolveImageSrc(val) {
  if (!val) return null;
  if (val.indexOf('http') === 0) return val;
  return constants.DOMAIN + '/' + val;
}

function StepProgress(props) {
  var steps = props.steps || [];
  var currentStep = props.currentStep;
  var isDark = document.documentElement.classList.contains('tw-dark');
  var doneCount = steps.filter(function(s) { return s.complete; }).length;
  return (
    <div className="tw-mb-5 tw-rounded-xl tw-p-4" style={{ backgroundColor: isDark ? '#111' : '#fafafa', border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
      <div className="tw-flex tw-items-center tw-justify-between tw-mb-3">
        <span className="tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider" style={{ color: '#c9a84c' }}>Setup Progress</span>
        <span className="tw-text-xs" style={{ color: '#999' }}>{doneCount} of {steps.length} complete</span>
      </div>
      <div className="tw-flex tw-items-start">
        {steps.map(function(step, i) {
          var isActive = step.key === currentStep;
          var bgColor = step.complete ? '#22c55e' : (isActive ? '#c9a84c' : (isDark ? '#333' : '#d0d0d0'));
          return (
            <div key={step.key} className="tw-flex tw-items-center" style={{ flex: 1 }}>
              <div className="tw-flex tw-flex-col tw-items-center tw-cursor-pointer" onClick={function() { if (props.onStepClick) props.onStepClick(step.key); }} style={{ minWidth: '48px' }}>
                <div className="tw-rounded-full tw-flex tw-items-center tw-justify-center tw-transition-all" style={{ width: 28, height: 28, backgroundColor: bgColor, boxShadow: isActive ? '0 0 0 3px ' + bgColor + '40' : 'none' }}>
                  {step.complete ? <i className="fa fa-check tw-text-white" style={{ fontSize: '11px' }} /> : <span className="tw-text-white tw-font-bold" style={{ fontSize: '11px' }}>{step.number}</span>}
                </div>
                <span className="tw-text-center tw-mt-1.5 tw-leading-tight" style={{ fontSize: '9px', fontWeight: isActive ? 700 : 500, color: isActive ? (isDark ? '#fff' : '#1a1a1a') : '#999', maxWidth: '60px' }}>{step.label}</span>
              </div>
              {i < steps.length - 1 && <div style={{ height: '2px', flex: 1, backgroundColor: step.complete ? '#22c55e' : (isDark ? '#2a2a2a' : '#e0e0e0'), marginTop: '-14px', minWidth: '8px' }} />}
            </div>
          );
        })}
      </div>
    </div>
  );
}

function SectionHelp(props) {
  var isDark = document.documentElement.classList.contains('tw-dark');
  return (
    <div className="tw-mb-3 tw-px-3.5 tw-py-2.5 tw-rounded-lg tw-flex tw-items-start tw-gap-2" style={{ backgroundColor: isDark ? 'rgba(59,130,246,0.08)' : 'rgba(59,130,246,0.06)', border: '1px solid ' + (isDark ? 'rgba(59,130,246,0.2)' : 'rgba(59,130,246,0.15)') }}>
      <i className="fa fa-info-circle tw-mt-0.5" style={{ color: '#3B82F6', fontSize: '12px', flexShrink: 0 }} />
      <p className="tw-text-xs tw-mb-0 tw-leading-relaxed" style={{ color: isDark ? '#93c5fd' : '#1e40af' }}>{props.children}</p>
    </div>
  );
}

function MiniToggle(props) {
  return (
    <label className="tw-flex tw-items-center tw-gap-1.5 tw-cursor-pointer tw-mb-0 tw-select-none">
      <button
        type="button"
        onClick={function() { props.onChange(!props.checked); }}
        className="tw-flex-shrink-0 tw-relative tw-border-0 tw-cursor-pointer tw-rounded-full tw-transition-colors"
        style={{ width: '32px', height: '18px', backgroundColor: props.checked ? (props.color || '#22c55e') : '#ccc', padding: 0 }}
      >
        <span className="tw-block tw-rounded-full tw-bg-white tw-transition-all" style={{ width: '14px', height: '14px', marginTop: '2px', marginLeft: props.checked ? '16px' : '2px', boxShadow: '0 1px 2px rgba(0,0,0,0.2)' }} />
      </button>
      <span className="tw-text-xs" style={{ color: props.labelColor || '#999' }}>{props.label}</span>
    </label>
  );
}

function ImageInput(props) {
  var value = props.value || '';
  var onChange = props.onChange;
  var onUpload = props.onUpload;
  var uploading = props.uploading;
  var label = props.label || 'Image';
  var fileRef = React.createRef();
  var src = resolveImageSrc(value);

  return (
    <div>
      <label className={labelCls}>{label}</label>
      <div className="tw-flex tw-items-center tw-gap-2">
        {src ? (
          <img src={src} alt="" className="tw-w-10 tw-h-10 tw-rounded tw-object-cover tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-flex-shrink-0" />
        ) : (
          <div className="tw-w-10 tw-h-10 tw-rounded tw-bg-[#f5f5f5] dark:tw-bg-[#222] tw-flex tw-items-center tw-justify-center tw-flex-shrink-0 tw-border tw-border-[#d0d0d0] dark:tw-border-[#555]">
            <i className="fa fa-image tw-text-[#ccc] dark:tw-text-[#555] tw-text-xs" />
          </div>
        )}
        <input
          type="text" value={value} placeholder="Image URL or path"
          onChange={function(e) { onChange(e.target.value); }}
          className={inputSmCls + ' tw-flex-1'}
        />
        {onUpload && (
          <button
            type="button"
            onClick={function() { fileRef.current.click(); }}
            disabled={uploading}
            className="tw-flex tw-items-center tw-gap-1 tw-px-2 tw-py-1 tw-rounded tw-text-xs tw-font-semibold tw-border-0 tw-cursor-pointer tw-transition-colors tw-flex-shrink-0"
            style={{ backgroundColor: '#6366f1', color: '#fff', opacity: uploading ? 0.5 : 1 }}
          >
            {uploading ? <i className="fa fa-spinner fa-spin" /> : <i className="fa fa-camera" />}
          </button>
        )}
        <input
          ref={fileRef} type="file" accept="image/jpeg,image/png,image/gif,image/webp"
          onChange={function(e) { if (e.target.files[0] && onUpload) onUpload(e.target.files[0]); e.target.value = ''; }}
          style={{ display: 'none' }}
        />
      </div>
      <p className="tw-text-[10px] tw-text-[#aaa] dark:tw-text-[#666] tw-mt-1 tw-mb-0">JPEG, PNG, GIF, WebP — Max 5MB</p>
    </div>
  );
}

class AdminGames extends Component {
  constructor(props) {
    super(props);
    this.state = {
      games: [],
      loading: true,
      expandedId: null,
      editData: {},
      saving: false,
      saveError: null,
      saveSuccess: null,
      creating: false,
      createData: {
        name: '', slug: '', description: '', logo: '', banner: '', active: true, sortOrder: 0,
        rarities: [], conditions: [], noFoilRarities: [], cardFields: [],
        setCategories: [], setImages: {}, comingSoonSets: [], syncConfig: {},
      },
      createError: null,
      editSection: null,
      // Set category helpers
      newCatSetInput: {},
      newCatCsInput: {},
      // Set image helpers
      newSetImageName: '',
      newSetImageUrl: '',
      // Upload state
      uploadingGameImage: '',
      uploadingSetImage: '',
      uploadError: null,
      justCreatedId: null,
    };
  }

  componentDidMount() {
    this.fetchGames();
    this._handleThemeChanged = function() { this.forceUpdate(); }.bind(this);
    window.addEventListener('themeChanged', this._handleThemeChanged);
  }

  componentWillUnmount() {
    if (this._handleThemeChanged) window.removeEventListener('themeChanged', this._handleThemeChanged);
  }

  fetchGames() {
    this.setState({ loading: true });
    fetch(constants.DOMAIN + '/api/v1/admin/games', {
      mode: 'cors', method: 'GET',
      headers: { Authorization: Auth.getAuthHeader() },
    })
      .then(r => r.json())
      .then(res => {
        this.setState({ games: res.games || [], loading: false });
      })
      .catch(err => {
        console.log('Failed to fetch games:', err);
        this.setState({ loading: false });
      });
  }

  toggleExpand(gameId) {
    if (this.state.expandedId === gameId) {
      this.setState({ expandedId: null, editData: {}, editSection: null, saveError: null, saveSuccess: null, newCatSetInput: {}, newCatCsInput: {}, newSetImageName: '', newSetImageUrl: '' });
    } else {
      var game = this.state.games.find(g => g._id === gameId);
      this.setState({
        expandedId: gameId,
        editData: game ? JSON.parse(JSON.stringify(game)) : {},
        editSection: null,
        saveError: null,
        saveSuccess: null,
        newCatSetInput: {},
        newCatCsInput: {},
        newSetImageName: '',
        newSetImageUrl: '',
      });
    }
  }

  handleEditChange(field, value) {
    this.setState(prev => ({
      editData: { ...prev.editData, [field]: value },
      saveSuccess: null,
    }));
  }

  handleCreateChange(field, value) {
    this.setState(prev => ({
      createData: { ...prev.createData, [field]: value },
      createError: null,
    }));
  }

  saveGame() {
    var self = this;
    var editData = this.state.editData;
    self.setState({ saving: true, saveError: null, saveSuccess: null });

    fetch(constants.DOMAIN + '/api/v1/admin/games/' + editData._id, {
      mode: 'cors', method: 'PATCH',
      headers: {
        Authorization: Auth.getAuthHeader(),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(editData),
    })
      .then(r => r.json())
      .then(res => {
        if (res.error) {
          self.setState({ saving: false, saveError: res.error });
        } else {
          self.setState({ saving: false, saveSuccess: 'Game saved successfully' }, function() {
            self.fetchGames();
            window.dispatchEvent(new Event('gamesChanged'));
          });
        }
      })
      .catch(() => {
        self.setState({ saving: false, saveError: 'Failed to save game' });
      });
  }

  createGame() {
    var self = this;
    var createData = this.state.createData;
    if (!createData.name || !createData.slug) {
      self.setState({ createError: 'Name and slug are required' });
      return;
    }
    self.setState({ saving: true, createError: null });

    fetch(constants.DOMAIN + '/api/v1/admin/games', {
      mode: 'cors', method: 'POST',
      headers: {
        Authorization: Auth.getAuthHeader(),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(createData),
    })
      .then(r => r.json())
      .then(res => {
        if (res.error) {
          self.setState({ saving: false, createError: res.error });
        } else {
          var newId = res.game ? res.game._id : null;
          self.setState({
            saving: false, creating: false,
            justCreatedId: newId,
            createData: {
              name: '', slug: '', description: '', logo: '', banner: '', active: true, sortOrder: 0,
              rarities: [], conditions: [], noFoilRarities: [], cardFields: [],
              setCategories: [], setImages: {}, comingSoonSets: [], syncConfig: {},
            },
          }, function() {
            self.fetchGames();
            window.dispatchEvent(new Event('gamesChanged'));
            // Auto-expand the newly created game
            if (newId) {
              setTimeout(function() {
                self.toggleExpand(newId);
              }, 500);
            }
          });
        }
      })
      .catch(() => {
        self.setState({ saving: false, createError: 'Failed to create game' });
      });
  }

  deactivateGame(gameId) {
    var self = this;
    fetch(constants.DOMAIN + '/api/v1/admin/games/' + gameId, {
      mode: 'cors', method: 'DELETE',
      headers: { Authorization: Auth.getAuthHeader() },
    })
      .then(r => r.json())
      .then(() => {
        self.fetchGames();
        self.setState({ expandedId: null });
        window.dispatchEvent(new Event('gamesChanged'));
      })
      .catch(err => {
        console.log('Failed to deactivate game:', err);
        self.setState({ saveError: 'Failed to deactivate game' });
      });
  }

  // Rarity helpers
  addRarity() {
    this.setState(prev => ({
      editData: {
        ...prev.editData,
        rarities: [...(prev.editData.rarities || []), { name: '', color: '#6b7280', textColor: '#ffffff', sortOrder: (prev.editData.rarities || []).length }],
      },
    }));
  }

  updateRarity(index, field, value) {
    this.setState(prev => {
      var rarities = [...(prev.editData.rarities || [])];
      rarities[index] = { ...rarities[index], [field]: value };
      return { editData: { ...prev.editData, rarities } };
    });
  }

  removeRarity(index) {
    this.setState(prev => {
      var rarities = [...(prev.editData.rarities || [])];
      rarities.splice(index, 1);
      return { editData: { ...prev.editData, rarities } };
    });
  }

  // Condition helpers
  addCondition() {
    this.setState(prev => ({
      editData: {
        ...prev.editData,
        conditions: [...(prev.editData.conditions || []), { value: '', label: '', hasFoil: true }],
      },
    }));
  }

  updateCondition(index, field, value) {
    this.setState(prev => {
      var conditions = [...(prev.editData.conditions || [])];
      conditions[index] = { ...conditions[index], [field]: value };
      return { editData: { ...prev.editData, conditions } };
    });
  }

  removeCondition(index) {
    this.setState(prev => {
      var conditions = [...(prev.editData.conditions || [])];
      conditions.splice(index, 1);
      return { editData: { ...prev.editData, conditions } };
    });
  }

  // Card field helpers
  addCardField() {
    this.setState(prev => ({
      editData: {
        ...prev.editData,
        cardFields: [...(prev.editData.cardFields || []), { key: '', label: '', type: 'string', showInFilters: false, showInDetail: true, showInListCard: false, displayOrder: (prev.editData.cardFields || []).length }],
      },
    }));
  }

  updateCardField(index, field, value) {
    this.setState(prev => {
      var cardFields = [...(prev.editData.cardFields || [])];
      cardFields[index] = { ...cardFields[index], [field]: value };
      return { editData: { ...prev.editData, cardFields } };
    });
  }

  removeCardField(index) {
    this.setState(prev => {
      var cardFields = [...(prev.editData.cardFields || [])];
      cardFields.splice(index, 1);
      return { editData: { ...prev.editData, cardFields } };
    });
  }

  // Set Category helpers
  addSetCategory() {
    this.setState(prev => {
      var cats = [...(prev.editData.setCategories || [])];
      cats.push({ label: 'New Category', sets: [], comingSoon: [] });
      return { editData: { ...prev.editData, setCategories: cats } };
    });
  }

  updateSetCategory(index, value) {
    this.setState(prev => {
      var cats = [...(prev.editData.setCategories || [])];
      cats[index] = { ...cats[index], label: value };
      return { editData: { ...prev.editData, setCategories: cats } };
    });
  }

  removeSetCategory(index) {
    this.setState(prev => {
      var cats = [...(prev.editData.setCategories || [])];
      cats.splice(index, 1);
      return { editData: { ...prev.editData, setCategories: cats } };
    });
  }

  addSetToCategory(catIndex) {
    var key = 'cat_' + catIndex;
    var val = (this.state.newCatSetInput[key] || '').trim();
    if (!val) return;
    this.setState(prev => {
      var cats = [...(prev.editData.setCategories || [])];
      var cat = { ...cats[catIndex], sets: [...(cats[catIndex].sets || [])] };
      if (cat.sets.indexOf(val) === -1) cat.sets.push(val);
      cats[catIndex] = cat;
      var inputs = { ...prev.newCatSetInput };
      inputs[key] = '';
      return { editData: { ...prev.editData, setCategories: cats }, newCatSetInput: inputs };
    });
  }

  removeSetFromCategory(catIndex, setIndex) {
    this.setState(prev => {
      var cats = [...(prev.editData.setCategories || [])];
      var cat = { ...cats[catIndex], sets: [...(cats[catIndex].sets || [])] };
      cat.sets.splice(setIndex, 1);
      cats[catIndex] = cat;
      return { editData: { ...prev.editData, setCategories: cats } };
    });
  }

  moveSetInCategory(catIndex, setIndex, direction) {
    this.setState(prev => {
      var cats = [...(prev.editData.setCategories || [])];
      var sets = [...(cats[catIndex].sets || [])];
      var newIndex = setIndex + direction;
      if (newIndex < 0 || newIndex >= sets.length) return null;
      var tmp = sets[newIndex];
      sets[newIndex] = sets[setIndex];
      sets[setIndex] = tmp;
      cats[catIndex] = { ...cats[catIndex], sets: sets };
      return { editData: { ...prev.editData, setCategories: cats } };
    });
  }

  moveComingSoonInCategory(catIndex, csIndex, direction) {
    this.setState(prev => {
      var cats = [...(prev.editData.setCategories || [])];
      var arr = [...(cats[catIndex].comingSoon || [])];
      var newIndex = csIndex + direction;
      if (newIndex < 0 || newIndex >= arr.length) return null;
      var tmp = arr[newIndex];
      arr[newIndex] = arr[csIndex];
      arr[csIndex] = tmp;
      cats[catIndex] = { ...cats[catIndex], comingSoon: arr };
      return { editData: { ...prev.editData, setCategories: cats } };
    });
  }

  addComingSoonToCategory(catIndex) {
    var key = 'cs_' + catIndex;
    var val = (this.state.newCatCsInput[key] || '').trim();
    if (!val) return;
    this.setState(prev => {
      var cats = [...(prev.editData.setCategories || [])];
      var cat = { ...cats[catIndex], comingSoon: [...(cats[catIndex].comingSoon || [])] };
      if (cat.comingSoon.indexOf(val) === -1) cat.comingSoon.push(val);
      cats[catIndex] = cat;
      var inputs = { ...prev.newCatCsInput };
      inputs[key] = '';
      return { editData: { ...prev.editData, setCategories: cats }, newCatCsInput: inputs };
    });
  }

  removeComingSoonFromCategory(catIndex, csIndex) {
    this.setState(prev => {
      var cats = [...(prev.editData.setCategories || [])];
      var cat = { ...cats[catIndex], comingSoon: [...(cats[catIndex].comingSoon || [])] };
      cat.comingSoon.splice(csIndex, 1);
      cats[catIndex] = cat;
      return { editData: { ...prev.editData, setCategories: cats } };
    });
  }

  // Set Image helpers
  commitSetImage() {
    var name = this.state.newSetImageName.trim();
    if (!name) return;
    this.setState(prev => {
      var imgs = { ...(prev.editData.setImages || {}) };
      if (!imgs[name]) imgs[name] = prev.newSetImageUrl || '';
      return { editData: { ...prev.editData, setImages: imgs }, newSetImageName: '', newSetImageUrl: '' };
    });
  }

  removeSetImage(name) {
    this.setState(prev => {
      var imgs = { ...(prev.editData.setImages || {}) };
      delete imgs[name];
      return { editData: { ...prev.editData, setImages: imgs } };
    });
  }

  updateSetImageUrl(name, url) {
    this.setState(prev => {
      var imgs = { ...(prev.editData.setImages || {}) };
      imgs[name] = url;
      return { editData: { ...prev.editData, setImages: imgs } };
    });
  }

  // Coming Soon Set helpers
  addComingSoonSet() {
    this.setState(prev => {
      var cs = [...(prev.editData.comingSoonSets || [])];
      cs.push({ name: '', image: '' });
      return { editData: { ...prev.editData, comingSoonSets: cs } };
    });
  }

  updateComingSoonSet(index, field, value) {
    this.setState(prev => {
      var cs = [...(prev.editData.comingSoonSets || [])];
      cs[index] = { ...cs[index], [field]: value };
      return { editData: { ...prev.editData, comingSoonSets: cs } };
    });
  }

  removeComingSoonSet(index) {
    this.setState(prev => {
      var cs = [...(prev.editData.comingSoonSets || [])];
      cs.splice(index, 1);
      return { editData: { ...prev.editData, comingSoonSets: cs } };
    });
  }

  // Image upload handlers
  handleGameImageUpload(gameId, field, file) {
    var self = this;
    self.setState({ uploadingGameImage: field });

    var formData = new FormData();
    formData.append('image', file);
    fetch(constants.DOMAIN + '/api/v1/admin/games/' + gameId + '/upload-image?field=' + field, {
      method: 'POST',
      headers: { Authorization: Auth.getAuthHeader() },
      body: formData,
    })
      .then(function(r) {
        if (!r.ok) return r.text().then(function(text) { try { var d = JSON.parse(text); throw new Error(d.error || 'Upload failed (HTTP ' + r.status + ')'); } catch(e) { if (e.message && e.message.indexOf('Upload failed') === 0) throw e; throw new Error('Upload failed (HTTP ' + r.status + ')'); } });
        return r.json();
      })
      .then(function(data) {
        self.setState({ uploadingGameImage: '' });
        if (data.game) {
          self.handleEditChange(field, data.game[field] || '');
          self.fetchGames();
        }
      })
      .catch(function(err) {
        self.setState({ uploadingGameImage: '', uploadError: err.message || 'Failed to upload game image' });
      });
  }

  handleSetImageUpload(gameId, setName, file) {
    var self = this;
    self.setState({ uploadingSetImage: setName });

    var formData = new FormData();
    formData.append('image', file);
    fetch(constants.DOMAIN + '/api/v1/admin/games/' + gameId + '/upload-set-image?setName=' + encodeURIComponent(setName), {
      method: 'POST',
      headers: { Authorization: Auth.getAuthHeader() },
      body: formData,
    })
      .then(function(r) {
        if (!r.ok) return r.text().then(function(text) { try { var d = JSON.parse(text); throw new Error(d.error || 'Upload failed (HTTP ' + r.status + ')'); } catch(e) { if (e.message && e.message.indexOf('Upload failed') === 0) throw e; throw new Error('Upload failed (HTTP ' + r.status + ')'); } });
        return r.json();
      })
      .then(function(data) {
        self.setState({ uploadingSetImage: '' });
        if (data.game) {
          self.handleEditChange('setImages', data.game.setImages || {});
          self.fetchGames();
        }
      })
      .catch(function(err) {
        self.setState({ uploadingSetImage: '', uploadError: err.message || 'Failed to upload set image' });
      });
  }

  // Get all set names from setCategories
  getAllSetNames() {
    var cats = this.state.editData.setCategories || [];
    var names = [];
    cats.forEach(function(cat) {
      (cat.sets || []).forEach(function(s) {
        if (names.indexOf(s) === -1) names.push(s);
      });
    });
    return names.sort();
  }

  getStepCompletion(editData) {
    var rarities = editData.rarities || [];
    var conditions = editData.conditions || [];
    var cardFields = editData.cardFields || [];
    var cats = editData.setCategories || [];
    var setImages = editData.setImages || {};
    var hasSets = cats.some(function(c) { return (c.sets || []).length > 0; });

    return [
      { key: 'basic', number: 1, label: 'Basic Info', icon: 'fa-pencil', complete: !!(editData.name && editData.slug) },
      { key: 'rarities', number: 2, label: 'Rarities', icon: 'fa-star', complete: rarities.length > 0 },
      { key: 'conditions', number: 3, label: 'Conditions', icon: 'fa-heart', complete: conditions.length > 0 },
      { key: 'cardFields', number: 4, label: 'Card Attributes', icon: 'fa-list', complete: cardFields.length > 0 },
      { key: 'setCategories', number: 5, label: 'Sets & Categories', icon: 'fa-folder', complete: cats.length > 0 && hasSets },
      { key: 'setImages', number: 6, label: 'Set Images', icon: 'fa-image', complete: Object.keys(setImages).length > 0 },
      { key: 'comingSoon', number: 7, label: 'Coming Soon', icon: 'fa-clock-o', complete: true },
    ];
  }

  renderGameForm(data, onChange, prefix) {
    var self = this;
    var isDark = document.documentElement.classList.contains('tw-dark');
    var isEdit = prefix === 'edit';
    var gameId = isEdit ? (self.state.editData._id || '') : '';

    return (
      <div className="tw-space-y-4">
        {/* Basic info */}
        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">
          <div>
            <label className={labelCls}>Name</label>
            <input
              type="text" value={data.name || ''}
              onChange={e => onChange('name', e.target.value)}
              className={inputCls} style={inputStyle(isDark)}
              placeholder="e.g. Primal TCG"
            />
          </div>
          <div>
            <label className={labelCls}>Slug (URL-safe)</label>
            <input
              type="text" value={data.slug || ''}
              onChange={e => onChange('slug', e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, '-'))}
              className={inputCls} style={inputStyle(isDark)}
              placeholder="e.g. primal-tcg"
            />
          </div>
        </div>

        <div>
          <label className={labelCls}>Description</label>
          <textarea
            value={data.description || ''} rows={2}
            onChange={e => onChange('description', e.target.value)}
            className={inputCls + ' tw-resize-y'}
          />
        </div>

        {/* Logo + Banner with dual-mode ImageInput */}
        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">
          <ImageInput
            label="Logo"
            value={data.logo || ''}
            onChange={function(url) { onChange('logo', url); }}
            onUpload={isEdit && gameId ? function(file) { self.handleGameImageUpload(gameId, 'logo', file); } : null}
            uploading={self.state.uploadingGameImage === 'logo'}
          />
          <ImageInput
            label="Banner"
            value={data.banner || ''}
            onChange={function(url) { onChange('banner', url); }}
            onUpload={isEdit && gameId ? function(file) { self.handleGameImageUpload(gameId, 'banner', file); } : null}
            uploading={self.state.uploadingGameImage === 'banner'}
          />
        </div>
        {!isEdit && <p className="tw-text-[10px] tw-text-[#aaa] dark:tw-text-[#666] tw-mt-0 tw-mb-0">File upload available after initial save</p>}

        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-4">
          <div>
            <label className={labelCls}>Sort Order</label>
            <input
              type="number" value={data.sortOrder || 0}
              onChange={e => onChange('sortOrder', parseInt(e.target.value) || 0)}
              className={inputCls} style={inputStyle(isDark)}
            />
          </div>
          <div className="tw-flex tw-items-end tw-pb-1">
            <MiniToggle
              checked={data.active !== false}
              onChange={function(val) { onChange('active', val); }}
              label="Active"
              labelColor={isDark ? '#fff' : '#1a1a1a'}
            />
          </div>
        </div>
      </div>
    );
  }

  renderRaritiesSection() {
    var rarities = this.state.editData.rarities || [];
    return (
      <div className="tw-mt-4">
        <SectionHelp>Define rarity tiers for this game (e.g. Common, Rare, Ultra Rare). Set background and text colors for the rarity badge. Order from most common to rarest.</SectionHelp>
        <div className="tw-flex tw-items-center tw-justify-between tw-mb-3">
          <h4 className="tw-text-sm tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-mb-0">Rarities ({rarities.length})</h4>
          <button onClick={() => this.addRarity()} className="tw-text-xs tw-font-semibold tw-text-brand-gold hover:tw-text-brand-gold-dark tw-bg-transparent tw-border-0 tw-cursor-pointer">
            + Add Rarity
          </button>
        </div>
        <div className="tw-space-y-2">
          {rarities.map((r, i) => (
            <div key={i} className="tw-flex tw-items-center tw-gap-2 tw-bg-[#f9f9f9] dark:tw-bg-[#141414] tw-rounded-lg tw-p-2">
              <input
                type="text" value={r.name} placeholder="Name"
                onChange={e => this.updateRarity(i, 'name', e.target.value)}
                className={inputSmCls + ' tw-flex-1'}
              />
              <label className="tw-text-xs tw-text-[#999] tw-flex tw-items-center tw-gap-1">
                BG:
                <input type="color" value={r.color || '#6b7280'} onChange={e => this.updateRarity(i, 'color', e.target.value)} className="tw-w-6 tw-h-6 tw-border-0 tw-cursor-pointer" aria-label={'Background color for ' + (r.name || 'rarity')} />
              </label>
              <label className="tw-text-xs tw-text-[#999] tw-flex tw-items-center tw-gap-1">
                Text:
                <input type="color" value={r.textColor || '#ffffff'} onChange={e => this.updateRarity(i, 'textColor', e.target.value)} className="tw-w-6 tw-h-6 tw-border-0 tw-cursor-pointer" aria-label={'Text color for ' + (r.name || 'rarity')} />
              </label>
              <span className="tw-text-xs tw-font-semibold tw-px-2 tw-py-0.5 tw-rounded-full" style={{ backgroundColor: r.color, color: r.textColor }}>{r.name || '?'}</span>
              <button onClick={() => this.removeRarity(i)} className="tw-text-red-500 hover:tw-text-red-400 tw-bg-transparent tw-border-0 tw-cursor-pointer tw-text-xs" aria-label={'Remove ' + (r.name || 'rarity')}>
                <i className="fa fa-trash" />
              </button>
            </div>
          ))}
        </div>
      </div>
    );
  }

  renderConditionsSection() {
    var conditions = this.state.editData.conditions || [];
    return (
      <div className="tw-mt-4">
        <SectionHelp>Card condition grades that sellers choose when listing (e.g. Near Mint, Lightly Played). Check 'Foil' if that condition supports foil variants.</SectionHelp>
        <div className="tw-flex tw-items-center tw-justify-between tw-mb-3">
          <h4 className="tw-text-sm tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-mb-0">Conditions ({conditions.length})</h4>
          <button onClick={() => this.addCondition()} className="tw-text-xs tw-font-semibold tw-text-brand-gold hover:tw-text-brand-gold-dark tw-bg-transparent tw-border-0 tw-cursor-pointer">
            + Add Condition
          </button>
        </div>
        <div className="tw-space-y-2">
          {conditions.map((c, i) => (
            <div key={i} className="tw-flex tw-items-center tw-gap-2 tw-bg-[#f9f9f9] dark:tw-bg-[#141414] tw-rounded-lg tw-p-2">
              <input
                type="text" value={c.value} placeholder="Value (NM, LP...)"
                onChange={e => this.updateCondition(i, 'value', e.target.value)}
                className={inputSmCls + ' tw-w-20'}
              />
              <input
                type="text" value={c.label} placeholder="Label"
                onChange={e => this.updateCondition(i, 'label', e.target.value)}
                className={inputSmCls + ' tw-flex-1'}
              />
              <MiniToggle
                checked={c.hasFoil !== false}
                onChange={function(val) { this.updateCondition(i, 'hasFoil', val); }.bind(this)}
                label="Foil"
              />
              <button onClick={() => this.removeCondition(i)} className="tw-text-red-500 hover:tw-text-red-400 tw-bg-transparent tw-border-0 tw-cursor-pointer tw-text-xs" aria-label={'Remove ' + (c.label || 'condition')}>
                <i className="fa fa-trash" />
              </button>
            </div>
          ))}
        </div>
      </div>
    );
  }

  renderCardFieldsSection() {
    var isDark = document.documentElement.classList.contains('tw-dark');
    var cardFields = this.state.editData.cardFields || [];
    return (
      <div className="tw-mt-4">
        <SectionHelp>Custom fields that appear on card detail pages (e.g. Element, Hand Cost). 'Key' is the internal name (lowercase, no spaces). 'Label' is what users see. Toggle 'Card Page' to show on product pages, 'Filters' to add to Browse filters.</SectionHelp>
        <div className="tw-flex tw-items-center tw-justify-between tw-mb-3">
          <h4 className="tw-text-sm tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-mb-0">Card Attributes ({cardFields.length})</h4>
          <button onClick={() => this.addCardField()} className="tw-text-xs tw-font-semibold tw-text-brand-gold hover:tw-text-brand-gold-dark tw-bg-transparent tw-border-0 tw-cursor-pointer">
            + Add Field
          </button>
        </div>
        <div className="tw-space-y-2">
          {cardFields.map((f, i) => (
            <div key={i} className="tw-flex tw-flex-wrap tw-items-center tw-gap-2 tw-bg-[#f9f9f9] dark:tw-bg-[#141414] tw-rounded-lg tw-p-2">
              <input
                type="text" value={f.key} placeholder="key"
                onChange={e => this.updateCardField(i, 'key', e.target.value)}
                className={inputSmCls + ' tw-w-24'}
              />
              <input
                type="text" value={f.label} placeholder="Label"
                onChange={e => this.updateCardField(i, 'label', e.target.value)}
                className={inputSmCls + ' tw-flex-1 tw-min-w-[80px]'}
              />
              <select
                value={f.type} onChange={e => this.updateCardField(i, 'type', e.target.value)}
                className={inputSmCls} style={inputStyle(isDark)}
              >
                <option value="string">String</option>
                <option value="number">Number</option>
                <option value="array">Array</option>
                <option value="boolean">Boolean</option>
              </select>
              <MiniToggle
                checked={f.showInDetail !== false}
                onChange={function(val) { this.updateCardField(i, 'showInDetail', val); }.bind(this)}
                label="Card Page"
              />
              <MiniToggle
                checked={!!f.showInFilters}
                onChange={function(val) { this.updateCardField(i, 'showInFilters', val); }.bind(this)}
                label="Filters"
                color="#6366f1"
              />
              <input
                type="number" value={f.displayOrder || 0} title="Display order"
                onChange={e => this.updateCardField(i, 'displayOrder', parseInt(e.target.value) || 0)}
                className={inputSmCls + ' tw-w-12 tw-text-center'}
              />
              <button onClick={() => this.removeCardField(i)} className="tw-text-red-500 hover:tw-text-red-400 tw-bg-transparent tw-border-0 tw-cursor-pointer tw-text-xs" aria-label={'Remove ' + (f.label || f.key || 'field')}>
                <i className="fa fa-trash" />
              </button>
            </div>
          ))}
        </div>
      </div>
    );
  }

  renderSetCategoriesSection() {
    var self = this;
    var cats = this.state.editData.setCategories || [];

    return (
      <div className="tw-mt-4">
        <SectionHelp>Organize card sets into categories for the Browse page (e.g. 'Booster Sets', 'Starter Decks'). Type a set name and press Enter to add it.</SectionHelp>
        <div className="tw-flex tw-items-center tw-justify-between tw-mb-3">
          <h4 className="tw-text-sm tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-mb-0">Sets &amp; Categories ({cats.length})</h4>
          <button onClick={() => self.addSetCategory()} className="tw-text-xs tw-font-semibold tw-text-brand-gold hover:tw-text-brand-gold-dark tw-bg-transparent tw-border-0 tw-cursor-pointer">
            + Add Category
          </button>
        </div>
        <div className="tw-space-y-4">
          {cats.map(function(cat, ci) {
            var setKey = 'cat_' + ci;
            var csKey = 'cs_' + ci;
            return (
              <div key={ci} className="tw-bg-[#f9f9f9] dark:tw-bg-[#141414] tw-rounded-lg tw-p-4 tw-border tw-border-[#d0d0d0] dark:tw-border-[#555]">
                <div className="tw-flex tw-items-center tw-gap-2 tw-mb-3">
                  <input
                    type="text" value={cat.label || ''} placeholder="Category label"
                    onChange={function(e) { self.updateSetCategory(ci, e.target.value); }}
                    className={inputSmCls + ' tw-flex-1 tw-font-semibold'}
                  />
                  <button onClick={function() { self.removeSetCategory(ci); }} className="tw-text-red-500 hover:tw-text-red-400 tw-bg-transparent tw-border-0 tw-cursor-pointer tw-text-xs" title="Remove category" aria-label={'Remove category ' + (cat.label || '')}>
                    <i className="fa fa-trash" />
                  </button>
                </div>

                {/* Sets */}
                <div className="tw-mb-3">
                  <label className="tw-text-xs tw-font-semibold tw-text-[#999] dark:tw-text-gray-500">Sets</label>
                  <div className="tw-flex tw-flex-wrap tw-gap-1.5 tw-mt-1">
                    {(cat.sets || []).map(function(s, si) {
                      var setsLen = (cat.sets || []).length;
                      return (
                        <span key={si} className="tw-inline-flex tw-items-center tw-gap-1 tw-text-xs tw-font-semibold tw-px-2.5 tw-py-1 tw-rounded-full tw-border" style={{ backgroundColor: '#fef3c7', color: '#92400e', borderColor: '#fcd34d' }}>
                          {si > 0 && <button onClick={function() { self.moveSetInCategory(ci, si, -1); }} className="tw-bg-transparent tw-border-0 tw-cursor-pointer tw-text-xs tw-p-0" style={{ color: '#92400e', opacity: 0.7 }} aria-label={'Move ' + s + ' left'} title="Move left">
                            <i className="fa fa-arrow-left" />
                          </button>}
                          {s}
                          {si < setsLen - 1 && <button onClick={function() { self.moveSetInCategory(ci, si, 1); }} className="tw-bg-transparent tw-border-0 tw-cursor-pointer tw-text-xs tw-p-0" style={{ color: '#92400e', opacity: 0.7 }} aria-label={'Move ' + s + ' right'} title="Move right">
                            <i className="fa fa-arrow-right" />
                          </button>}
                          <button onClick={function() { self.removeSetFromCategory(ci, si); }} className="tw-bg-transparent tw-border-0 tw-cursor-pointer tw-text-xs tw-p-0 tw-ml-0.5" style={{ color: '#92400e' }} aria-label={'Remove set ' + s}>
                            <i className="fa fa-times" />
                          </button>
                        </span>
                      );
                    })}
                    <div className="tw-flex tw-items-center tw-gap-1">
                      <input
                        type="text" value={self.state.newCatSetInput[setKey] || ''} placeholder="Add set..."
                        onChange={function(e) { var v = e.target.value; self.setState(function(prev) { var i = { ...prev.newCatSetInput }; i[setKey] = v; return { newCatSetInput: i }; }); }}
                        onKeyDown={function(e) { if (e.key === 'Enter') { e.preventDefault(); self.addSetToCategory(ci); } }}
                        className={inputSmCls + ' tw-w-28'}
                      />
                      <button onClick={function() { self.addSetToCategory(ci); }} className="tw-text-xs tw-font-semibold tw-text-brand-gold hover:tw-text-brand-gold-dark tw-bg-transparent tw-border-0 tw-cursor-pointer">Add</button>
                    </div>
                  </div>
                </div>

                {/* Coming Soon within category */}
                <div>
                  <label className="tw-text-xs tw-font-semibold tw-text-[#999] dark:tw-text-gray-500">Coming Soon</label>
                  <div className="tw-flex tw-flex-wrap tw-gap-1.5 tw-mt-1">
                    {(cat.comingSoon || []).map(function(cs, csi) {
                      var csLen = (cat.comingSoon || []).length;
                      return (
                        <span key={csi} className="tw-inline-flex tw-items-center tw-gap-1 tw-text-xs tw-font-semibold tw-px-2.5 tw-py-1 tw-rounded-full tw-border" style={{ backgroundColor: '#ede9fe', color: '#5b21b6', borderColor: '#c4b5fd' }}>
                          {csi > 0 && <button onClick={function() { self.moveComingSoonInCategory(ci, csi, -1); }} className="tw-bg-transparent tw-border-0 tw-cursor-pointer tw-text-xs tw-p-0" style={{ color: '#5b21b6', opacity: 0.7 }} aria-label={'Move ' + cs + ' left'} title="Move left">
                            <i className="fa fa-arrow-left" />
                          </button>}
                          {cs}
                          {csi < csLen - 1 && <button onClick={function() { self.moveComingSoonInCategory(ci, csi, 1); }} className="tw-bg-transparent tw-border-0 tw-cursor-pointer tw-text-xs tw-p-0" style={{ color: '#5b21b6', opacity: 0.7 }} aria-label={'Move ' + cs + ' right'} title="Move right">
                            <i className="fa fa-arrow-right" />
                          </button>}
                          <button onClick={function() { self.removeComingSoonFromCategory(ci, csi); }} className="tw-bg-transparent tw-border-0 tw-cursor-pointer tw-text-xs tw-p-0 tw-ml-0.5" style={{ color: '#5b21b6' }} aria-label={'Remove coming soon ' + cs}>
                            <i className="fa fa-times" />
                          </button>
                        </span>
                      );
                    })}
                    <div className="tw-flex tw-items-center tw-gap-1">
                      <input
                        type="text" value={self.state.newCatCsInput[csKey] || ''} placeholder="Add..."
                        onChange={function(e) { var v = e.target.value; self.setState(function(prev) { var i = { ...prev.newCatCsInput }; i[csKey] = v; return { newCatCsInput: i }; }); }}
                        onKeyDown={function(e) { if (e.key === 'Enter') { e.preventDefault(); self.addComingSoonToCategory(ci); } }}
                        className={inputSmCls + ' tw-w-28'}
                      />
                      <button onClick={function() { self.addComingSoonToCategory(ci); }} className="tw-text-xs tw-font-semibold tw-text-brand-gold hover:tw-text-brand-gold-dark tw-bg-transparent tw-border-0 tw-cursor-pointer">Add</button>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  renderSetImagesSection() {
    var self = this;
    var setImages = this.state.editData.setImages || {};
    var entries = Object.keys(setImages).sort();
    var allSets = self.getAllSetNames();
    var gameId = self.state.editData._id || '';

    return (
      <div className="tw-mt-4">
        <SectionHelp>Upload a banner image for each set. These appear as thumbnails on the Browse page. Sets must be added in Sets &amp; Categories first.</SectionHelp>
        <div className="tw-flex tw-items-center tw-justify-between tw-mb-3">
          <h4 className="tw-text-sm tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-mb-0">Set Images ({entries.length})</h4>
        </div>
        <div className="tw-space-y-3">
          {entries.map(function(name) {
            return (
              <div key={name} className="tw-flex tw-items-start tw-gap-3 tw-bg-[#f9f9f9] dark:tw-bg-[#141414] tw-rounded-lg tw-p-3 tw-border tw-border-[#d0d0d0] dark:tw-border-[#555]">
                <span className="tw-text-xs tw-font-semibold tw-text-[#1a1a1a] dark:tw-text-white tw-whitespace-nowrap tw-pt-1 tw-min-w-[80px]">{name}</span>
                <div className="tw-flex-1">
                  <ImageInput
                    label=""
                    value={setImages[name] || ''}
                    onChange={function(url) { self.updateSetImageUrl(name, url); }}
                    onUpload={gameId ? function(file) { self.handleSetImageUpload(gameId, name, file); } : null}
                    uploading={self.state.uploadingSetImage === name}
                  />
                </div>
                <button onClick={function() { self.removeSetImage(name); }} className="tw-text-red-500 hover:tw-text-red-400 tw-bg-transparent tw-border-0 tw-cursor-pointer tw-text-xs tw-pt-1">
                  <i className="fa fa-trash" />
                </button>
              </div>
            );
          })}

          {/* Add new set image */}
          <div className="tw-flex tw-items-end tw-gap-2 tw-bg-[#f0fdf4] dark:tw-bg-[#0a2e1a] tw-rounded-lg tw-p-3 tw-border tw-border-green-300 dark:tw-border-green-800">
            <div className="tw-w-32">
              <label className={labelCls}>Set Name</label>
              <select
                value={self.state.newSetImageName}
                onChange={function(e) { self.setState({ newSetImageName: e.target.value }); }}
                className={inputSmCls + ' tw-w-full'}
              >
                <option value="">Select set...</option>
                {allSets.filter(function(s) { return !setImages[s]; }).map(function(s) {
                  return <option key={s} value={s}>{s}</option>;
                })}
              </select>
            </div>
            <div className="tw-flex-1">
              <label className={labelCls}>Image URL</label>
              <input
                type="text" value={self.state.newSetImageUrl} placeholder="Image URL (optional)"
                onChange={function(e) { self.setState({ newSetImageUrl: e.target.value }); }}
                className={inputSmCls + ' tw-w-full'}
              />
            </div>
            <button
              onClick={function() { self.commitSetImage(); }}
              disabled={!self.state.newSetImageName}
              className="tw-px-3 tw-py-1 tw-rounded tw-text-xs tw-font-semibold tw-border-0 tw-cursor-pointer tw-transition-colors tw-flex-shrink-0"
              style={{ backgroundColor: '#22c55e', color: '#fff', opacity: self.state.newSetImageName ? 1 : 0.4 }}
            >
              + Add
            </button>
          </div>
        </div>
      </div>
    );
  }

  renderComingSoonSection() {
    var self = this;
    var comingSoonSets = this.state.editData.comingSoonSets || [];
    var gameId = self.state.editData._id || '';

    return (
      <div className="tw-mt-4">
        <SectionHelp>Preview upcoming sets with a promotional image. These appear on the Browse page but won't show in search until you create actual cards.</SectionHelp>
        <div className="tw-flex tw-items-center tw-justify-between tw-mb-3">
          <h4 className="tw-text-sm tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-mb-0">Coming Soon Sets ({comingSoonSets.length})</h4>
          <button onClick={() => self.addComingSoonSet()} className="tw-text-xs tw-font-semibold tw-text-brand-gold hover:tw-text-brand-gold-dark tw-bg-transparent tw-border-0 tw-cursor-pointer">
            + Add Set
          </button>
        </div>
        <div className="tw-space-y-3">
          {comingSoonSets.map(function(cs, i) {
            return (
              <div key={i} className="tw-flex tw-items-start tw-gap-3 tw-bg-[#f9f9f9] dark:tw-bg-[#141414] tw-rounded-lg tw-p-3 tw-border tw-border-[#d0d0d0] dark:tw-border-[#555]">
                <div className="tw-w-40">
                  <label className={labelCls}>Name</label>
                  <input
                    type="text" value={cs.name || ''} placeholder="Set name"
                    onChange={function(e) { self.updateComingSoonSet(i, 'name', e.target.value); }}
                    className={inputSmCls + ' tw-w-full'}
                  />
                </div>
                <div className="tw-flex-1">
                  <ImageInput
                    label="Image"
                    value={cs.image || ''}
                    onChange={function(url) { self.updateComingSoonSet(i, 'image', url); }}
                    onUpload={gameId ? function(file) {
                      // Upload coming soon image via set image endpoint using the set name
                      self.handleSetImageUpload(gameId, cs.name || 'coming-soon-' + i, file);
                    } : null}
                    uploading={self.state.uploadingSetImage === (cs.name || 'coming-soon-' + i)}
                  />
                </div>
                <button onClick={function() { self.removeComingSoonSet(i); }} className="tw-text-red-500 hover:tw-text-red-400 tw-bg-transparent tw-border-0 tw-cursor-pointer tw-text-xs tw-pt-1">
                  <i className="fa fa-trash" />
                </button>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  render() {
    var self = this;
    var isDark = document.documentElement.classList.contains('tw-dark');
    var { games, loading, expandedId, editData, saving, saveError, saveSuccess, creating, createData, createError } = this.state;

    return (
      <div>
        {/* Upload error modal */}
        {this.state.uploadError && (
          <div
            className="tw-fixed tw-inset-0 tw-z-50 tw-flex tw-items-center tw-justify-center"
            style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
            onClick={function() { self.setState({ uploadError: null }); }}
            role="dialog"
            aria-modal="true"
            aria-labelledby="upload-error-title"
          >
            <div
              className="tw-rounded-xl tw-shadow-2xl tw-p-6 tw-max-w-md tw-mx-4"
              style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#333' : '#e0e0e0') }}
              onClick={function(e) { e.stopPropagation(); }}
            >
              <div className="tw-flex tw-items-start tw-gap-3 tw-mb-4">
                <div className="tw-w-10 tw-h-10 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-flex-shrink-0" style={{ backgroundColor: '#fef2f2' }}>
                  <i className="fa fa-exclamation-triangle" style={{ color: '#ef4444', fontSize: '18px' }} />
                </div>
                <div>
                  <h3 id="upload-error-title" className="tw-text-base tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-mb-1">Upload Failed</h3>
                  <p className="tw-text-sm tw-text-[#666] dark:tw-text-gray-400 tw-mb-0">{this.state.uploadError}</p>
                </div>
              </div>
              <div className="tw-flex tw-justify-end">
                <button
                  onClick={function() { self.setState({ uploadError: null }); }}
                  className="tw-px-4 tw-py-2 tw-rounded-lg tw-text-sm tw-font-semibold tw-border-0 tw-cursor-pointer tw-transition-colors"
                  style={{ backgroundColor: '#ef4444', color: '#fff' }}
                >
                  Dismiss
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Header */}
        <div className="tw-flex tw-items-center tw-justify-between tw-mb-6">
          <div>
            <h2 className="tw-text-xl tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-mb-1">Games</h2>
            <p className="tw-text-sm tw-text-[#999] dark:tw-text-gray-500 tw-mb-0">
              Manage game configurations, rarities, conditions, and card fields
            </p>
          </div>
          <button
            onClick={() => self.setState({ creating: !creating })}
            className="tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-rounded-lg tw-text-sm tw-font-semibold tw-border-0 tw-cursor-pointer tw-transition-colors"
            style={{ backgroundColor: creating ? '#ef4444' : '#22c55e', color: '#fff' }}
          >
            <i className={creating ? 'fa fa-times' : 'fa fa-plus'} />
            {creating ? 'Cancel' : 'Add Game'}
          </button>
        </div>

        {/* Create panel */}
        {creating && (
          <div className="tw-mb-6 tw-bg-[#f0fdf4] dark:tw-bg-[#0a2e1a] tw-rounded-xl tw-border tw-border-green-300 dark:tw-border-green-800 tw-p-5">
            <h3 className="tw-text-sm tw-font-bold tw-text-green-800 dark:tw-text-green-300 tw-mb-4">Create New Game</h3>
            {this.renderGameForm(createData, (f, v) => self.handleCreateChange(f, v), 'create')}
            {createError && (
              <p className="tw-text-red-500 tw-text-xs tw-mt-2 tw-mb-0">{createError}</p>
            )}
            <div className="tw-mt-4">
              <button
                onClick={() => self.createGame()}
                disabled={saving}
                className="tw-px-4 tw-py-2 tw-rounded-lg tw-text-sm tw-font-semibold tw-border-0 tw-cursor-pointer tw-transition-colors"
                style={{ backgroundColor: '#22c55e', color: '#fff', opacity: saving ? 0.5 : 1 }}
              >
                {saving ? 'Creating...' : 'Create Game'}
              </button>
            </div>
          </div>
        )}

        {/* Game list */}
        {loading ? (
          <div className="tw-space-y-3">
            {[1, 2].map(i => (
              <div key={i} className="tw-h-16 tw-rounded-xl tw-animate-pulse" style={{ backgroundColor: isDark ? '#1a1a1a' : '#f5f5f5' }} />
            ))}
          </div>
        ) : games.length === 0 ? (
          <p className="tw-text-center tw-text-[#999] dark:tw-text-gray-500 tw-text-sm tw-mt-12">
            No games configured. Create one to get started.
          </p>
        ) : (
          <div className="tw-space-y-3">
            {games.map(function(game) {
              var isExpanded = expandedId === game._id;
              var logoSrc = resolveImageSrc(game.logo);
              return (
                <div key={game._id} className="tw-rounded-xl tw-overflow-hidden" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#333' : '#e0e0e0') }}>
                  {/* Row header */}
                  <button
                    onClick={() => self.toggleExpand(game._id)}
                    className="tw-w-full tw-flex tw-items-center tw-justify-between tw-p-4 tw-bg-transparent tw-border-0 tw-cursor-pointer tw-text-left hover:tw-bg-[#f9f9f9] dark:hover:tw-bg-[#141414] tw-transition-colors"
                  >
                    <div className="tw-flex tw-items-center tw-gap-3">
                      {logoSrc ? (
                        <img src={logoSrc} alt={game.name} className="tw-w-8 tw-h-8 tw-rounded tw-object-contain" />
                      ) : (
                        <div className="tw-w-8 tw-h-8 tw-rounded tw-bg-brand-gold/20 tw-flex tw-items-center tw-justify-center">
                          <i className="fa fa-gamepad tw-text-brand-gold tw-text-sm" />
                        </div>
                      )}
                      <div>
                        <span className="tw-text-sm tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white">{game.name}</span>
                        <span className="tw-text-xs tw-text-[#999] dark:tw-text-gray-500 tw-ml-2">/{game.slug}</span>
                      </div>
                      <span className={'tw-text-xs tw-font-semibold tw-px-2 tw-py-0.5 tw-rounded-full ' + (game.active ? 'tw-bg-green-100 dark:tw-bg-green-900/30 tw-text-green-700 dark:tw-text-green-400' : 'tw-bg-red-100 dark:tw-bg-red-900/30 tw-text-red-700 dark:tw-text-red-400')}>
                        {game.active ? 'Active' : 'Inactive'}
                      </span>
                    </div>
                    <div className="tw-flex tw-items-center tw-gap-3 tw-text-xs tw-text-[#999] dark:tw-text-gray-500">
                      <span>{(game.rarities || []).length} rarities</span>
                      <span>{(game.conditions || []).length} conditions</span>
                      <span>{(game.cardFields || []).length} fields</span>
                      <i className={'fa ' + (isExpanded ? 'fa-chevron-up' : 'fa-chevron-down')} />
                    </div>
                  </button>

                  {/* Expanded edit */}
                  {isExpanded && (
                    <div className="tw-border-t tw-border-[#d0d0d0] dark:tw-border-[#555] tw-p-5">
                      {/* Getting Started banner — only for newly created games */}
                      {self.state.justCreatedId === game._id && (
                        <div className="tw-mb-5 tw-rounded-xl tw-p-4 tw-flex tw-items-start tw-gap-3" style={{ background: isDark ? 'linear-gradient(135deg, #064e3b, #022c22)' : 'linear-gradient(135deg, #ecfdf5, #d1fae5)', border: '1px solid ' + (isDark ? '#065f46' : '#6ee7b7') }}>
                          <div className="tw-w-10 tw-h-10 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-flex-shrink-0" style={{ backgroundColor: isDark ? '#065f46' : '#a7f3d0' }}>
                            <i className="fa fa-rocket" style={{ color: '#10b981', fontSize: '16px' }} />
                          </div>
                          <div className="tw-flex-1">
                            <h4 className="tw-text-sm tw-font-bold tw-mb-1" style={{ color: isDark ? '#6ee7b7' : '#065f46' }}>Game Created! Let's Configure It</h4>
                            <p className="tw-text-xs tw-mb-0" style={{ color: isDark ? '#a7f3d0' : '#047857' }}>
                              Follow the 7-step setup below to fully configure your game. Start with Basic Info, then add rarities, conditions, and card attributes. Finally, organize your sets and upload images.
                            </p>
                          </div>
                          <button onClick={function() { self.setState({ justCreatedId: null }); }} className="tw-bg-transparent tw-border-0 tw-cursor-pointer tw-text-xs tw-font-semibold tw-flex-shrink-0" style={{ color: isDark ? '#6ee7b7' : '#065f46' }}>Got it</button>
                        </div>
                      )}

                      {/* Step progress bar */}
                      <StepProgress
                        steps={self.getStepCompletion(editData)}
                        currentStep={self.state.editSection || 'basic'}
                        onStepClick={function(key) {
                          if (key === 'basic') {
                            self.setState({ editSection: null });
                          } else {
                            self.setState({ editSection: key });
                          }
                        }}
                      />

                      {self.renderGameForm(editData, (f, v) => self.handleEditChange(f, v), 'edit')}

                      {/* Config sections — numbered tabs with icons */}
                      <div className="tw-mt-6 tw-flex tw-flex-wrap tw-gap-2 tw-mb-4">
                        {[
                          { key: 'rarities', label: 'Rarities', icon: 'fa-star', num: '2' },
                          { key: 'conditions', label: 'Conditions', icon: 'fa-heart', num: '3' },
                          { key: 'cardFields', label: 'Card Attributes', icon: 'fa-list', num: '4' },
                          { key: 'setCategories', label: 'Sets & Categories', icon: 'fa-folder', num: '5' },
                          { key: 'setImages', label: 'Set Images', icon: 'fa-image', num: '6' },
                          { key: 'comingSoon', label: 'Coming Soon', icon: 'fa-clock-o', num: '7' },
                        ].map(function(tab) {
                          var active = self.state.editSection === tab.key;
                          return (
                            <button
                              key={tab.key}
                              onClick={function() { self.setState({ editSection: active ? null : tab.key }); }}
                              className={'tw-px-3 tw-py-1.5 tw-rounded-lg tw-text-xs tw-font-semibold tw-border tw-cursor-pointer tw-transition-colors tw-flex tw-items-center tw-gap-1.5 ' + (active ? 'tw-border-brand-gold' : 'tw-bg-transparent tw-text-[#999] dark:tw-text-gray-500 tw-border-[#d0d0d0] dark:tw-border-[#555] hover:tw-border-brand-gold')}
                              style={active ? { backgroundColor: '#c9a84c', color: '#000', borderColor: '#c9a84c' } : {}}
                            >
                              <i className={'fa ' + tab.icon} style={{ fontSize: '10px' }} />
                              <span style={{ fontSize: '10px', fontWeight: 700, opacity: 0.6 }}>{tab.num}</span>
                              {tab.label}
                            </button>
                          );
                        })}
                      </div>

                      {self.state.editSection === 'rarities' && self.renderRaritiesSection()}
                      {self.state.editSection === 'conditions' && self.renderConditionsSection()}
                      {self.state.editSection === 'cardFields' && self.renderCardFieldsSection()}
                      {self.state.editSection === 'setCategories' && self.renderSetCategoriesSection()}
                      {self.state.editSection === 'setImages' && self.renderSetImagesSection()}
                      {self.state.editSection === 'comingSoon' && self.renderComingSoonSection()}

                      {/* Actions */}
                      <div className="tw-mt-6 tw-flex tw-items-center tw-gap-3">
                        <button
                          onClick={() => self.saveGame()}
                          disabled={saving}
                          className="tw-px-4 tw-py-2 tw-rounded-lg tw-text-sm tw-font-semibold tw-border-0 tw-cursor-pointer tw-bg-brand-gold hover:tw-bg-brand-gold-dark tw-text-black tw-transition-colors"
                          style={{ opacity: saving ? 0.5 : 1 }}
                        >
                          {saving ? 'Saving...' : 'Save Changes'}
                        </button>
                        <button
                          onClick={() => self.toggleExpand(game._id)}
                          disabled={saving}
                          className="tw-px-4 tw-py-2 tw-rounded-lg tw-text-sm tw-font-semibold tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-transparent tw-text-[#999] dark:tw-text-gray-500 tw-cursor-pointer tw-transition-colors hover:tw-border-brand-gold"
                          style={{ opacity: saving ? 0.5 : 1 }}
                        >
                          Cancel
                        </button>
                        {game.active && (
                          <button
                            onClick={() => { if (window.confirm('Deactivate "' + game.name + '"? This will hide it from the public site.')) self.deactivateGame(game._id); }}
                            disabled={saving}
                            className="tw-px-4 tw-py-2 tw-rounded-lg tw-text-sm tw-font-semibold tw-border-0 tw-cursor-pointer tw-bg-red-500 hover:tw-bg-red-600 tw-text-white tw-transition-colors tw-ml-auto"
                            style={{ opacity: saving ? 0.5 : 1 }}
                          >
                            Deactivate
                          </button>
                        )}
                      </div>

                      {saveError && <p className="tw-text-red-500 tw-text-xs tw-mt-2 tw-mb-0">{saveError}</p>}
                      {saveSuccess && <p className="tw-text-green-500 tw-text-xs tw-mt-2 tw-mb-0">{saveSuccess}</p>}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }
}

export default AdminGames;
